const CONSENT_KEY = 'posthog_consent';

export type ConsentStatus = 'granted' | 'denied' | 'pending';

export function getConsentStatus(): ConsentStatus {
  if (typeof window === 'undefined') return 'pending';
  return (localStorage.getItem(CONSENT_KEY) as ConsentStatus) || 'pending';
}

export function setConsentStatus(status: 'granted' | 'denied'): void {
  localStorage.setItem(CONSENT_KEY, status);
}
